/**
 * HScrollBar parser: delegates to the shared ScrollBar base (Control +
 * Range + `custom_step`). HScrollBar adds no properties of its own; only the
 * draw axis differs, which is the Component's business.
 */
import { parseScrollBar } from '../shared/scrollBar';
export function parseHScrollBar(heading, properties) {
    return parseScrollBar(heading, properties);
}
//# sourceMappingURL=parser.js.map